import { useLocation } from '@tanstack/react-router'

import { Skeleton } from '@/_components/ui/skeleton'

import { companyColumns } from '../_columns/company-table-column'
import { getApplicationColumns } from '../_columns/application-table-columns'
import { usersColumns } from '../_columns/users-table-column'
import { LoadingDataTable } from '../_components/loading-data-table'
import { Container } from '../_components/ui/container'
import { Header, HeaderLeft, HeaderRight } from '../_components/ui/header'
import { useIsRouteActive } from '../_hooks/use-is-route-active'

export default function Loading() {
  const isPersonRouteActive = useIsRouteActive('companies', 'persons')
  const isUsersRouteActive = useIsRouteActive('companies', 'users')

  const { pathname } = useLocation()

  const isCompanyRoute = pathname === '/companies'
  return (
    <Container className="px-14 py-10 gap-6">
      <Header>
        <HeaderLeft>
          <Skeleton className="h-[20px] w-[300px] rounded-full" />
        </HeaderLeft>
        <HeaderRight>
          <Skeleton className="h-[20px] w-[200px] rounded-full" />
        </HeaderRight>
      </Header>
      {isPersonRouteActive && (
        <LoadingDataTable
          columns={getApplicationColumns({ showFacility: false, userType: 'tenant' })}
        />
      )}

      {isCompanyRoute && <LoadingDataTable columns={companyColumns} />}

      {isUsersRouteActive && <LoadingDataTable columns={usersColumns} />}
    </Container>
  )
}
